module.exports = __webpack_public_path__ + "static/media/phcs_id_practitioner_ancillary_only.02ee9f47.jpg";